import React from 'react';
import { motion } from 'framer-motion';
export function MidPageCTA() {
  return <section className="bg-[#17304F] py-10 px-6" data-id="element-163">
      <div className="max-w-3xl mx-auto text-center" data-id="element-164">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-165">
          <a href="#offer" onClick={e => {
          e.preventDefault();
          document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-block bg-orange-500 hover:bg-orange-600 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-xl shadow-lg shadow-orange-500/25 transition-all transform hover:scale-105 active:scale-95 w-full sm:w-auto border-b-4 border-orange-700" data-id="element-166">
            QUIERO EL MANUAL (PDF)
          </a>
          <p className="text-sm text-slate-300 mt-4 font-medium" data-id="element-167">
            Ebook digital · Acceso inmediato · Pago único
          </p>
        </motion.div>
      </div>
    </section>;
}